import React from "react";
import HandleJsonUpload from "../Handle/HandleJsonUpload";

function JsonUpload() {
  return <HandleJsonUpload />;
}

export default JsonUpload;
